import { CreateApplicationUrlByLoanJaccsResopnseParam } from '~/composables/order-entry'

class Form {
  form: HTMLFormElement
  constructor(baseParams: CreateApplicationUrlByLoanJaccsResopnseParam) {
    this.form = document.createElement('form')
    this.form.action = baseParams.url
    this.form.method = 'POST'
    this.form.acceptCharset = 'Shift_JIS'
    document.body.appendChild(this.form)
    Object.keys(baseParams.form_data).forEach((key) => {
      this.appendChild(key, baseParams.form_data[key as keyof typeof baseParams.form_data])
    })
  }

  appendChild(name: string, value: any) {
    const inputElement = document.createElement('input')
    inputElement.type = 'hidden'
    inputElement.name = name
    inputElement.value = value
    this.form.appendChild(inputElement)
  }

  submit() {
    this.form.submit()
  }
}

const submitForm = (params: CreateApplicationUrlByLoanJaccsResopnseParam) => {
  const form = new Form(params)
  form.submit()
}

export const useJaccs = () => {
  return {
    submitForm,
  }
}
